require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-locations-chinandega.json") })
        }
      }, "path---es-locations-chinandega");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-locations-chinandega!./.cache/json/es-locations-chinandega.json
// module id = 1102
// module chunks = 231608221292675